import FormSetup from '../form-contents/Setup';
import CostsForDelivery from '../form-contents/CostsForDelivery';
import AreasContent from '../form-contents/Areas';

const MainForm = ({
  data,
  onChange,
  showOtherBlocks = true,
  deliveryZips,
  handleChangeDeliveryZips,
  onClickCreateDelivery,
  onDeleteDelivery,
  errors,
}) => {
  return (
    <>
      <FormSetup
        data={data}
        onChange={onChange}
      />
      {showOtherBlocks && (
        <>
          <CostsForDelivery data={data} onChange={onChange} />
          <AreasContent
            onClickCreateDelivery={onClickCreateDelivery}
            onDeleteDelivery={onDeleteDelivery}
            data={data}
            onChange={onChange}
            deliveryZips={deliveryZips}
            handleChangeDeliveryZips={handleChangeDeliveryZips}
            errors={errors}
          />
        </>
      )}
    </>
  );
};

export default MainForm;
